import PolicyLayout from "../components/PolicyLayout";

const AboutPage = () => {
  return (
    <PolicyLayout title="About Us" lastUpdated="February 2026">
      <p className="text-base leading-relaxed mb-6">
        <strong>theSnugglePrints</strong> is a pet-art studio that turns the
        pets you love into beautifully printed, frame-worthy portraits. Every
        piece is made from your photo and produced on premium materials by
        our fulfillment partners here in India.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">What we do</h3>
      <p className="text-base leading-relaxed mb-6">
        Upload a photo of your pet, give us their name, and within a minute
        or two you receive a print-ready portrait featuring your pet in a
        soft, semi-realistic illustration style. Once you approve, we print
        it on premium 8×8 inch canvas and ship it directly to your door.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">Why we built this</h3>
      <p className="text-base leading-relaxed mb-6">
        We believe pets are family. They deserve more than a phone-gallery
        snapshot — they deserve wall space. Our mission is to make premium,
        personalised pet art accessible to every pet parent, at a fair price,
        with zero hassle.
      </p>

      <h3 className="text-2xl font-bold mt-10 mb-4">How it works</h3>
      <ol className="list-decimal ml-6 space-y-2 mb-6">
        <li>Upload your pet's photo and name</li>
        <li>We craft a print-ready portrait made from your photo</li>
        <li>Preview the result and pay securely via Razorpay</li>
        <li>Your canvas is printed and shipped within 7–10 business days</li>
      </ol>

      <h3 className="text-2xl font-bold mt-10 mb-4">Get in touch</h3>
      <p className="text-base leading-relaxed mb-6">
        Questions, feedback, or custom requests? Reach us at{" "}
        <strong>contact@thesnuggleprints.com</strong> or visit our{" "}
        <a href="/contact" className="underline font-medium">
          Contact Us
        </a>{" "}
        page.
      </p>
    </PolicyLayout>
  );
};

export default AboutPage;
